// extracted by mini-css-extract-plugin
export default {"more-menu":"more-menu_more-menu__JE9sC"};